import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Discipline over drama.",
    body: "Every officer is drilled on communication, de-escalation, documentation, and the operational language of the industry they serve. Presence without spectacle. Authority without noise.",
  },
  {
    n: "02",
    title: "Coverage built for scale.",
    body: "One operating standard delivered from Winnipeg to the fly-in camps of Thompson. Mining, corporate, event, industrial, residential — served by dispatch cells positioned across the province.",
  },
  {
    n: "03",
    title: "Documentation you can audit.",
    body: "GPS-verified patrol checkpoints, time-stamped reports, incident logs with photograph evidence, and a client portal that surfaces every visit. Presence you can measure.",
  },
  {
    n: "04",
    title: "A Manitoba company. Only Manitoba.",
    body: "We do not chase national contracts. Our operating capacity is directed entirely to Manitoba communities — the geography, the industries, the winters, and the people we serve.",
  },
];

const IMG =
  "https://images.unsplash.com/photo-1529747598642-d0b4e3667314?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxzZWN1cml0eSUyMGd1YXJkJTIwcGF0cm9sJTIwbmlnaHR8ZW58MHx8fHwxNzg1MTA1NzIwfDA&ixlib=rb-4.1.0&q=85";

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto"
      className="relative bg-[#050505] border-t border-[#1e1e1e] py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
        <div className="col-span-12 md:col-span-4">
          <p className="font-editorial italic text-[#FF3B30] text-sm">
            03 — Manifesto
          </p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <h2 className="font-display font-black uppercase tracking-tightest leading-[0.9] text-white text-4xl md:text-6xl lg:text-7xl">
            The elite{" "}
            <span className="font-editorial italic font-normal text-[#a0a0a0]">
              standard,
            </span>
            <br />
            in four chapters.
          </h2>
        </div>
      </div>

      <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-5 md:sticky md:top-32 self-start">
          <div className="aspect-[4/5] w-full overflow-hidden bg-[#0b0b0b] clip-editorial">
            <img
              src={IMG}
              alt="Manitoba Security personnel — grayscale editorial portrait"
              className="h-full w-full object-cover grayscale contrast-125"
              loading="lazy"
            />
          </div>
        </div>

        <div className="col-span-12 md:col-span-7 space-y-16 md:space-y-24">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              data-testid={`manifesto-chapter-${c.n}`}
              className="grid grid-cols-12 gap-4 items-start"
            >
              <div className="col-span-3 md:col-span-2">
                <span className="font-editorial italic text-[#FF3B30] text-5xl md:text-6xl leading-none block">
                  {c.n}
                </span>
              </div>
              <div className="col-span-9 md:col-span-10">
                <h3 className="font-display uppercase tracking-tight text-white text-2xl md:text-3xl leading-tight mb-4">
                  {c.title}
                </h3>
                <p className="font-body text-base md:text-lg text-[#a0a0a0] leading-relaxed max-w-xl">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
